import React, {useCallback} from "react";
import BrowserAdaptiveLayout from "src/components/layout/BrowserAdaptiveLayout";
import {useHistory, useParams} from "react-router-dom";
import {EnvironmentUtils} from "filkersjs-model/dist";
import axios, {AxiosResponse} from "axios";
import ReactGA from 'react-ga';
import {useQuery} from "react-query";
import FilkersLoading from "src/components/commons/FilkersLoading";
import FilkersError from "src/components/commons/FilkersError";
import {VirtualWindowDataResponse} from "src/model/VirtualWindowDataResponse";
import MainPanel from "src/components/main/MainPanel";

const MainPage = () => {

    ReactGA.initialize('UA-182954976-1');

    const {uuid, uuidElement} = useParams<any>();

    const history = useHistory();
    const goBackToMain = useCallback(() => {
        history.push(`/${uuid}.html`);
    }, [uuid, history])

    const goToProductDetails = useCallback((itemUid) => {
        history.push(`/${uuid}/${itemUid}.html`);
    }, [uuid, history])

    function fetchDownloadData() {
        const serviceUrl = `${EnvironmentUtils.getHost()}/api/vw/v1/data/${uuid}`;
        return axios(serviceUrl)
            .then((rsp: AxiosResponse<VirtualWindowDataResponse>) => rsp.data)
    }

    const {isLoading, isError, data} = useQuery('todos', fetchDownloadData)

    if (isLoading === true || data === undefined) {
        return <FilkersLoading/>;
    } else if (isError === true) {
        return <FilkersError/>
    }


    return (
        <BrowserAdaptiveLayout>
            <MainPanel
                data={data} itemUid={uuidElement}
                onBackButtonPressed={goBackToMain}
                onItemSelected={goToProductDetails}
            />
        </BrowserAdaptiveLayout>
    )
}


export default MainPage;